
import {
  QUESTION_TEMPLATE_GET_DATA,
  QUESTION_TEMPLATE_GET_DETAILS_DATA,
  QUESTION_TEMPLATE_FORM_ADD_DATA,
  QUESTION_TEMPLATE_FORM_UPDATE_DATA,
  QUESTION_TEMPLATE_RESET,  
} from "./Constants";

const initialState = {
  loading: false,
  error: null,
  questionlist: {},
  question: {},
  questionform: {},
  addSuccess: false,
  updateSuccess: false,      
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {

    //load all list
    case QUESTION_TEMPLATE_GET_DATA.QUESTION_TEMPLATE_GET_DATA_LOAD:
      return {
        ...state,
        loading: true,
        questionlist: {},
        error: null,
      };
    case QUESTION_TEMPLATE_GET_DATA.QUESTION_TEMPLATE_GET_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        questionlist: { data: action.questionlist },
      };
    case QUESTION_TEMPLATE_GET_DATA.QUESTION_TEMPLATE_GET_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    //load by id 
    case QUESTION_TEMPLATE_GET_DETAILS_DATA.QUESTION_TEMPLATE_GET_DETAILS_DATA_LOAD:
      return {
        ...state,
        loading: true,
        question: {},
        error: null,
      };
    case QUESTION_TEMPLATE_GET_DETAILS_DATA.QUESTION_TEMPLATE_GET_DETAILS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        question: { data: action.question },
      };
    case QUESTION_TEMPLATE_GET_DETAILS_DATA.QUESTION_TEMPLATE_GET_DETAILS_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    // Add 
    case QUESTION_TEMPLATE_FORM_ADD_DATA.QUESTION_TEMPLATE_FORM_ADD_DATA_LOAD:
      return {
        ...state,
        loading: true,
        questionform: {},
        addSuccess: false,
        error: null,
      };
    case QUESTION_TEMPLATE_FORM_ADD_DATA.QUESTION_TEMPLATE_FORM_ADD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        questionform: action.questionform,
        addSuccess: true,
        error: null,
      };
    case QUESTION_TEMPLATE_FORM_ADD_DATA.QUESTION_TEMPLATE_FORM_ADD_DATA_FAIL:
      return {
        ...state,
        loading: false,
        questionform: {},
        addSuccess: false,
        error: action.error,
      };
    // Update 
    case QUESTION_TEMPLATE_FORM_UPDATE_DATA.QUESTION_TEMPLATE_FORM_UPDATE_DATA_LOAD:
      return {
        ...state,
        loading: true,
        updateSuccess: false,
        error: null
      }
    case QUESTION_TEMPLATE_FORM_UPDATE_DATA.QUESTION_TEMPLATE_FORM_UPDATE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        questionform: action.questionform,
        updateSuccess: true,
        error: false
      }
    case QUESTION_TEMPLATE_FORM_UPDATE_DATA.QUESTION_TEMPLATE_FORM_UPDATE_DATA_FAIL:
      return {
        ...state,
        loading: false,
        updateSuccess: false,
        error: action.error
      }
    case QUESTION_TEMPLATE_RESET:
      return {
        ...state,
        addSuccess: false,
        updateSuccess: false,
        error: null,
      };

    default:
      return {
        ...state,
      };
  }
};
export default Reducer;
